export const DEFAULT_DOCUMENT_TITLE = 'PA'

export const COMPANY_NAMES = {
    xFCsAZPU4PoOgll12MQO: 'Boston Project LLC',
    F2QrwHnQQFxrcEMoLXE8: 'Es-Metals',
    vXxvVIjmbKt5XTusXbhD: 'Componenti',
}

export function applyDocumentTitle() {
    let companyId = null
    try {
        const raw = localStorage.getItem('company')
        if (raw) {
            companyId = JSON.parse(raw)
        }
    } catch {
        companyId = null
    }
    const companyName = companyId ? COMPANY_NAMES[String(companyId)] : null
    document.title = companyName
        ? `${DEFAULT_DOCUMENT_TITLE} - ${companyName}`
        : DEFAULT_DOCUMENT_TITLE
}
